import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getToken } from 'lib/utils/getToken';

import { onError } from '@apollo/client/link/error';

const httpLink = createHttpLink({
  uri: new URL('/graphql', import.meta.env.VITE_APP_BASE_URL ?? window.location.origin).toString(),
});

const authLink = setContext((_, { headers }: { headers: Headers }) => {
  // get the authentication token from local storage if it exists
  const token = getToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

// Log any GraphQL errors or network error that occurred
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (const { message } of graphQLErrors) {
      console.error(`[GraphQL error]: Message: ${message}`);
    }
  }

  if (networkError) {
    console.error('[Network error]:', networkError);
  }
});

const cache = new InMemoryCache();

export const createApolloClient = () => {
  return new ApolloClient({
    link: errorLink.concat(authLink).concat(httpLink),
    cache,
  });
};

export const apolloClient = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache,
});
